// Breakpoints
export const breakpoints = {
  mobile: 480,
  tablet: 768,
  laptop: 1024,
  desktop: 1280,
};

// Helper untuk dapatkan ukuran layar saat ini
export const getScreenSize = () => {
  const width = window.innerWidth;
  return {
    isMobile: width < breakpoints.tablet,
    isTablet: width >= breakpoints.tablet && width < breakpoints.laptop,
    isLaptop: width >= breakpoints.laptop && width < breakpoints.desktop,
    isDesktop: width >= breakpoints.desktop,
    width,
  };
};

// Spacing system
export const spacing = {
  xs: '8px',
  sm: '12px',
  md: '16px',
  lg: '24px',
  xl: '32px',
  xxl: '48px',
  xxxl: '64px',
};

// Typography system
export const typography = {
  h1Mobile: '24px',
  h1Desktop: '36px',
  h2Mobile: '20px',
  h2Desktop: '26px',
  h3Mobile: '16px',
  h3Desktop: '20px',
  bodyMobile: '14px',
  bodyDesktop: '15px',
  smallMobile: '12px',
  smallDesktop: '13px',
};

// Container max widths
export const containers = {
  sm: '640px',
  md: '768px',
  lg: '1024px',
  xl: '1280px',
};